"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustBeLessOrEqual = void 0;
const compare_measure_1 = require("../../functions/compare-measure/compare-measure");
const format_measure_1 = require("../../functions/format-measure/format-measure");
const is_measure_1 = require("../../functions/is-measure/is-measure");
const is_number_1 = require("../../functions/is-number/is-number");
const parse_number_1 = require("../../functions/parse-number/parse-number");
const validation_1 = require("../validation/validation");
function mustBeLessOrEqual(limit, message) {
    if ((0, is_measure_1.isMeasure)(limit)) {
        return (0, validation_1.validation)(message ?? `The given value must be less than or equal to ${(0, format_measure_1.formatMeasure)(limit)}.`, (value) => !(0, is_measure_1.isMeasure)(value) || (0, compare_measure_1.compareMeasure)(value, limit) <= 0);
    }
    return (0, validation_1.validation)(message ?? `The given value must be less than or equal to ${limit}.`, (value) => {
        if (typeof value === 'string') {
            return !(0, is_number_1.isNumber)(value) || (0, parse_number_1.parseNumber)(value) <= limit;
        }
        return value == null || value <= limit;
    });
}
exports.mustBeLessOrEqual = mustBeLessOrEqual;
